export default "__VITE_ASSET__DUuL60b$__"